import { render, staticRenderFns } from "./04-Review.vue?vue&type=template&id=325d1ece&scoped=true&"
import script from "./04-Review.vue?vue&type=script&lang=js&"
export * from "./04-Review.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325d1ece",
  null
  
)

export default component.exports